// Validates a VAT ID input field against European VAT ID formats
export function validateVatId (vatIdInput: HTMLInputElement | null, vatId: string, errorMessage: string): void {
    if (!vatIdInput) return

    const trimmedVatId = vatId?.trim()

    if (!trimmedVatId) {
        vatIdInput.setCustomValidity('')
        return
    }

    // Remove common separators (-, ., space) before validation
    const cleanedVatId = trimmedVatId.replace(/[-.\s]/g, '')

    /* VAT ID pattern validation for European countries:
    - Standard: 2-letter country code (e.g. DE, AT, FR) + 2-13 digits (e.g. DE123456789, FR12345678901)
    - Switzerland: CHE + 9 digits (e.g. CHE123456789 or CHE-123.456.789) */
    if (!/^(CHE[0-9]{9}|[A-Z]{2}[A-Z0-9]{2,13})$/i.test(cleanedVatId)) {
        vatIdInput.setCustomValidity(errorMessage)
        vatIdInput.reportValidity()
    } else {
        vatIdInput.setCustomValidity('')
    }
}
